import React from 'react';
import { SEMANTIC_HR_HERO } from '../../../content/enterpriseMessaging';
import PoweredBySnowflake from './PoweredBySnowflake';

/**
 * Semantic HR lockup: title + tagline bottom-aligned on one row; logo below the title.
 */
export default function SemanticHRProductHeader({
  as: Tag = 'h3',
  titleClassName = 'text-2xl font-semibold tracking-tight text-ink-900',
  taglineClassName = 'text-sm font-medium text-brand-700 leading-snug',
  logoClassName = 'mt-0.5 h-5 w-auto object-contain',
  showTm = true,
  showLogo = true,
  layout = 'default',
}) {
  if (layout === 'stack') {
    return (
      <div className="space-y-1">
        <Tag className={titleClassName}>
          {SEMANTIC_HR_HERO.product}
          {showTm && <sup className="ml-0.5 text-[0.55em] font-normal align-super">™</sup>}
        </Tag>
        <p className={taglineClassName}>{SEMANTIC_HR_HERO.tagline}</p>
        {showLogo ? (
          <PoweredBySnowflake inline className={logoClassName} />
        ) : null}
      </div>
    );
  }

  // Below sm the tagline stacks under the title; side by side it would compress to a
  // few characters per line once the product name itself wraps.
  return (
    <div className="inline-grid min-w-0 max-w-full grid-cols-1 gap-y-1 sm:grid-cols-[auto_auto] sm:gap-x-2 sm:gap-y-0">
      <Tag className={`col-start-1 row-start-1 min-w-0 sm:self-end sm:shrink-0 ${titleClassName}`}>
        {SEMANTIC_HR_HERO.product}
        {showTm && <sup className="ml-0.5 text-[0.55em] font-normal align-super">™</sup>}
      </Tag>
      <p className={`col-start-1 row-start-2 min-w-0 max-w-full sm:col-start-2 sm:row-start-1 sm:self-end sm:-translate-y-1 ${taglineClassName}`}>
        {SEMANTIC_HR_HERO.tagline}
      </p>
      {showLogo ? (
        <PoweredBySnowflake
          inline
          className={`col-start-1 row-start-3 max-w-full sm:row-start-2 sm:justify-self-end sm:max-w-none ${logoClassName}`}
        />
      ) : null}
    </div>
  );
}
